import JSX from "../helpers/react.js";

export function OtherListsStatistics({max, count, title}: {title: string; max: number; count: number}) {
    const opacity: number = count / max,
        opacity_val: number = (+opacity.toFixed(2)) * 0.4 + 0.6;
    const bg = `rgba(60, 206, 123, ${opacity_val})`;

    return (<div className="stats-item">
        <div className="stats-item-column progress-bar-column">
            <div className="progress-bar">
                <div style={{
                    flexBasis: `${(count * 100 / max)}%`,
                    background: bg
                }}>
                    {count}
                </div>
            </div>
        </div>
        <div className="stats-item-column">{title}</div>
    </div>);
}